import { combineReducers } from 'redux';
import userReducer from './user/user.reducers';
import fetchReducer from './fetch/fetch.reducers';
import courseReducer from './course/course.reducers';
import quizReducer from './quiz/quiz.reducers';
import questionReducer from './question/question.reducers';
import imagesReducer from './images/images.reducers';
import scoreReducer from './score/score.reducers';
import feedbackReducer from './feedback/feedback.reducers';

const reducers = {
    fetchController: fetchReducer,
    courses: courseReducer,
    user: userReducer,
    quiz: quizReducer,
    question: questionReducer,
    images: imagesReducer,
    score: scoreReducer,
    feedback: feedbackReducer,
};

const rootReducer = combineReducers(reducers);

export type GlobalState = ReturnType<typeof rootReducer>;
export default rootReducer;
